import { Directive, ElementRef, inject, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { StaticAssetUrlPipe } from './static-asset-url.pipe';

@Directive({
  selector: '[rmaStaticAssetBg]',
  standalone: true,
  providers: [StaticAssetUrlPipe],
})
export class StaticAssetUrlBgDirective implements OnChanges {
  @Input('rmaStaticAssetBg')
  public source?: string;
  private readonly staticAssetPipe = inject(StaticAssetUrlPipe);
  private readonly elRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['source'] && this.source) {
      const url = this.staticAssetPipe.transform(this.source);
      this.renderer.setStyle(this.elRef.nativeElement, 'backgroundImage', `url(${url})`);
    }
  }
}
